import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { Form, Spinner } from 'react-bootstrap'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'
import { message } from 'antd'

import ReviewTaskForm from './ReviewTaskForm'

import { storeReviewTask } from '../services'
import { handleError } from '../../../helpers'

export default function NewReviewTaskModal({ visible, onClose, reload, serviceReview }) {
	const [loading, setLoading] = useState(false)
	const { handleSubmit, register, formState: { errors } } = useForm({
		defaultValues: { service_review_id: serviceReview.id }
	})

	const onSubmit = values => {
		setLoading(true)
		storeReviewTask(values)
			.then(res => {
				message.success(res.data.message)
				reload()
				onClose()
			})
			.catch(error => handleError(error, setLoading))
	}

	return (
		<React.Fragment>
			<Modal isOpen={visible} toggle={onClose}>
				<ModalHeader toggle={onClose}>Registrar actividad en diagnóstico</ModalHeader>
				<ModalBody>
					<Form onSubmit={handleSubmit(onSubmit)}>
						<ReviewTaskForm 
							register={register}
							errors={errors}
							serviceReview={serviceReview}
						/>
						<Button color='primary' type="submit" disabled={loading}>
							{ loading && <Spinner animation='border' size="sm" className='mr-1' /> }
							Registrar Actividad
						</Button>
					</Form>
				</ModalBody>
			</Modal>
		</React.Fragment>
	)
}